import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ClientModel } from '../../shared/models/client.model';
import { CommonHttpService } from '../../shared/services/http.service';
import { Response } from '@angular/http';
import { OauthService } from '../../shared/services/oauth.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'account-profile',
    templateUrl: './account.profile.component.html',
    styleUrls: ['./../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountProfileComponent {
    public client: ClientModel = new ClientModel();
    public loading = false;

    constructor(
        protected titleService: Title,
        protected translate: TranslateService,
        protected http: CommonHttpService,
        protected router: Router,
        protected oauth: OauthService,
        protected route: ActivatedRoute,
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.oauth.init();
            }
        });

        this.translate.get('ACCOUNT.PROFILE.TITLE').subscribe((title: string) => {
            this.titleService.setTitle(title+ ' | ' + this.route.snapshot.data.storeConfigurations.store_name);
        });
        this.oauth.loadingAuthenticatedUser$.subscribe(_ => {
            this.loading = true;
        });
        this.oauth.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.loading = false;
            this.client = client;
        });
        this.oauth.failedAuthenticatedUser$.subscribe((error: Response) => {
            this.loading = false;
            this.redirectOnFailAuthentication(error.status);
        });
        this.oauth.failedPersistedUser$.subscribe((error: Response) => {
            this.loading = false;
            this.redirectOnFailAuthentication(error.status);
        });
        this.oauth.tokenRefused$.subscribe(() => {
            this.loading = false;
            this.redirectOnFailAuthentication();
        });
        this.oauth.tokenGranted$.subscribe(() => {
            this.loading = false;
        });
    }

    /**
     * Redirect to index when request status code is unauthorized.
     **/
    private redirectOnFailAuthentication(statusCode = 401) {
        if (statusCode === 401) {
            window.location.href = '/';
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/account/profile/account.profile.component.ts